export const entryPage: string = '/order-tracker';
export const orderSummaryPage: string = '/order-tracker/order-tracker-summary';
export const sloPage: string = '/order-tracker/slo';
export const OCSOrderTrackerPage: string = '/online/track-your-projects/?f=';
